import type { UserSessionData } from './AuthContext';

export const patchSessionHideWhatsNew = (session: UserSessionData, hideWhatsNew: boolean): UserSessionData => ({
  ...session,
  user: { ...session.user, hideWhatsNew }
});
